import logo from '@assets/logo.webp'
import logoWhite from '@assets/logo_white.webp'

const Logo = ({ dark, width, height, style }) => (
  <img
    src={dark ? logo : logoWhite}
    alt='Magnitude.io - Powered by Curiosity'
    style={{ width, height, objectFit: 'contain', display: 'block', ...style }}
  />
)

export default Logo
